<!-- prettier-ignore -->

<div  class="chat__typing chat__typing--visible">
  <div class="my message">
    <span class="jumping-dots">
      <span class="dot-1"></span>
      <span class="dot-2"></span>
      <span class="dot-3"></span>
    </span>
  </div>
</div>

